import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Add } from '@mui/icons-material';

/**
 * Botão de incluir das TELAS — verde preenchido.
 *
 * A aparência vem da classe `.c4u-btn-icon--add` do CSS, não de estilo inline: antes cada
 * tela repetia as cores e as medidas por conta, e apareceram cantos de 6px e 8px para o
 * mesmo botão (achado do Hilton, 02/09/2026).
 *
 * Para ação dentro de SEÇÃO interna — abas do cadastro, blocos de uma tela — o botão é o
 * contornado (`.c4u-btn-icon--outline`), não este.
 */
interface AddButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  title?: string;
  disabled?: boolean;
}

const AddButton: React.FC<AddButtonProps> = ({ onClick, title = 'Adicionar', disabled = false }) => (
  <Tooltip title={title}>
    <span>
      <IconButton
        onClick={onClick}
        disabled={disabled}
        className="c4u-btn-icon c4u-btn-icon--add"
      >
        <Add />
      </IconButton>
    </span>
  </Tooltip>
);

export default AddButton;
